import { Box, Grid } from '@mui/material';
import classNames from 'classnames';
import ActiveOrder from '../ActiveOrder';
import OrderBookDivider from '../OrderBookDivider';
import OrderBookHeader from '../OrderBookHeader';
import OrderBookList from '../OrderBookList';
import OrderBookListFooter from '../OrderBookListFooter';
import { OrderbookIds } from '../enums/orderbookElementsIds';
import { useOrderBookStyles } from '../styles/OrderBookStyles';

const OrdersOnBook = () => {
  const { classes, cx } = useOrderBookStyles();

  return (
    <Grid container className={cx(classes.ordersOnBookContainer, classes.orderBookContainer)}>
      <Grid className={classes.item}>
        <Box className={classNames(classes.horizontalPadding)}>
          <OrderBookHeader />
        </Box>
      </Grid>
      <Grid className={classes.item}>
        <Grid container spacing={1}>
          <Grid className={classes.item}>
            <Box className={classNames(classes.activeOrderPadding)}>
              <ActiveOrder />
            </Box>
          </Grid>

          <Grid className={classes.item}>
            <Box
              id={OrderbookIds.ORDERBOOK_LIST}
              className={classNames(classes.horizontalPadding, classes.footerTitleContainer)}
            >
              <OrderBookList />
            </Box>
          </Grid>
        </Grid>
      </Grid>
      <Grid className={classes.footerContainer}>
        <Grid container spacing={0}>
          <Grid className={classNames(classes.item, classes.divider)}>
            <OrderBookDivider />
          </Grid>
          <Grid className={classes.item}>
            <Box
              id={OrderbookIds.ORDERBOOK_FOOTER}
              className={classNames(classes.horizontalPadding)}
            >
              <OrderBookListFooter />
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default OrdersOnBook;
